import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import hero from '../assets/images/hero/blog.jpg'
import icon4 from '../assets/images/branding/icon9.png'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
// import Blogall from '../components/blogall'
import Blogpaginated from '../components/blogpaginated'
import { Helmet } from 'react-helmet-async'

export default function Blog() {
    const basedomain = process.env.REACT_APP_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Blog | Hospital Aranda de La Parra</title>
                <meta name="description" content="Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos." />
                <meta property="og:title" content="Blog | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos." />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/blog`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Blog | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos." />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Blog | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos." />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Blog</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Blog</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>


            <section className="section">
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-3 col-4 text-center">
                            <img src={icon4} className="img-fluid w-50 mx-auto" alt="" />
                        </div>
                    </div>
                </div>
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Blog</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    Nuestro blog es un espacio dedicado a compartir información valiosa sobre salud, bienestar y avances médicos.
                                </p>

                            </div>
                        </div>
                    </div>
                    <Blogpaginated />
                </div>
            </section>
            <Footer />
            <ScrollToTop />
        </>
    )
}
